var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('section',{staticClass:"modal-wrap"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal"},[_c('h3',[_vm._v("信息正在审核中")]),_vm._v(" "),_c('div',[_c('span',{staticClass:"confirm",on:{"click":_vm.confirm}},[_vm._v("确定")])])])]),_vm._v(" "),_c('div',{staticClass:"bg"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ab05e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = null
// module chunks = 